import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

export type SearchCompanyRequest = {
  companyName: string;
  incorporationCountry: string;
};

export type SearchAddressRequest = {
  line: string;
  postalCode: string;
  country: string;
};

export class Lookups extends Resource<{}> {
  constructor(axiosInstance: AxiosInstance) {
    super("lookup", axiosInstance);
  }

  public async searchCompany(
    searchCompanyRequest: SearchCompanyRequest
  ): Promise<object> {
    const path = `companies`;
    return this.request({
      method: Method.POST,
      body: { ...searchCompanyRequest },
      path
    });
  }

  public async getCompany(id: string): Promise<object> {
    const path = `companies/${id}`;
    return this.request({ method: Method.GET, path });
  }

  public async searchAddress(
    searchAddressRequest: SearchAddressRequest
  ): Promise<object> {
    const path = `addresses`;
    return this.request({
      method: Method.POST,
      body: { ...searchAddressRequest },
      path
    });
  }
}
